import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CourtName } from './courtname';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CourtNameService {
  baseUrl: string = environment.serviceUrl;

  constructor(private httpClient: HttpClient) {
  }

  getAll(): Observable<CourtName[]> {
    return this.httpClient.get<CourtName[]>(this.baseUrl + 'api/CourtNameApi');
  }

  post(court: CourtName): Observable<any> {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post(this.baseUrl + 'api/CourtNameApi/Add', court, { headers: header, observe: 'response' });
  }

  delete(court: CourtName) {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post(this.baseUrl + 'api/CourtNameApi/activeordeactive', court, { headers: header, observe: 'response' });
  }

  put(court: CourtName): Observable<any> {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.put(this.baseUrl + 'api/CourtNameApi/Update', court, { headers: header, observe: 'response' });
  }

}
